var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Modal',{ref:"modal",attrs:{"action-label":_vm.$t('shared.modal.beforeUnload.confirm'),"title":_vm.$t('shared.modal.beforeUnload.title'),"subtitle":_vm.$t('shared.modal.beforeUnload.notice'),"icon":"save","data-test-id":"before-unload-modal","disable-click-outside":""},on:{"save":_vm.onConfirm,"close":_vm.onCancel}})
}
var staticRenderFns = []

export { render, staticRenderFns }